import { ChangeDetectorRef, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { BusyService } from './services/busy-service';
import { CartService } from './services/cart';
import { SwUpdate } from '@angular/service-worker';
import { MessageDialogService } from './services/message-dialog';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.html',
  styleUrl: './app.scss',
  imports: [
    RouterOutlet,
    RouterModule,
    MatToolbarModule,
    MatGridListModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    CommonModule
  ]
})
export class App {
  isBusy: Observable<boolean>;
  cartCount$: Observable<number>;
  protected title = 'a1-route-sales';
  isCartEmpty = false;
  constructor(
    private busyService: BusyService,
    private cartService: CartService,
    private cdRef: ChangeDetectorRef,
    messageDialog: MessageDialogService,
    swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          messageDialog.confirm('A new version is available. Reload to update?').subscribe((c: boolean) => {
            if (c) swUpdate.activateUpdate().then(() => document.location.reload());
          })
        }
      });
    }
    this.isBusy = this.busyService.isBusy$;
    this.cartCount$ = this.cartService.cartChanges$.pipe(
      tap(products => {
        Promise.resolve().then(() => {
          this.isCartEmpty = products.length === 0;
          this.cdRef.detectChanges();
        });
      }),
      map(products =>
        products.reduce((sum, item) => sum +  Number(item.quantity), 0)
      )
    );
  }
}
